import { jwtDecode } from 'jwt-decode';

import {
  TOKEN_LOCAL_STORAGE_KEY,
  VERIFIER_SESSION_STORAGE_KEY,
} from './constants';
import { LocalStorage } from './storage';
import type { IJwtPayload } from './types';

const clearUserOrgPreference = (token: string) => {
  if (token) {
    try {
      const payload = jwtDecode<IJwtPayload>(token);
      if (payload?.sub) {
        LocalStorage.remove(`${payload.sub}_org`);
      }
    } catch (error) {
      console.error('Error decoding token for cleanup:', error);
    }
  }

  try {
    const keysToRemove = LocalStorage.keys().filter(key =>
      key.endsWith('_org')
    );
    keysToRemove.forEach(key => LocalStorage.remove(key));
  } catch (error) {
    console.error('Error clearing user org preferences:', error);
  }
};

export const clearAuthStorage = (token: string): void => {
  LocalStorage.remove(TOKEN_LOCAL_STORAGE_KEY);
  LocalStorage.remove(VERIFIER_SESSION_STORAGE_KEY);
  clearUserOrgPreference(token);
};
